export const commentSubmit ={
    methods: {
        async saveComment(data)
        {
            console.log(data);
            try {
                const response = await this.$store.dispatch("posts/registerComment", data);
                //console.log(response.comment);
                if(response.isComment)
                {
                    //this.selectedPost.comments.push(response.comment);
                    //this.selectedPost.comments = response.comment;
                    console.log(this.$store.state.posts.viewpost);
                    console.log("댓글 등록 확인",response.comment);
                    this.$store.state.posts.viewpost.comments = response.comment;      
                    

                    this.$store.commit('updateUserPoint',response.user);
                    if(response.levelchange)
                    {
                    alert('레벨이 변경되었습니다.');
                    }
                }
                this.$flashMessage.show({type: response.state,title: response.message,message: response.message,});

                let elems =  document.querySelectorAll('.ccomment_form');
                let index = 0, length = elems.length;
                for ( ; index < length; index++) {
                    elems[index].style.display = "none";                     
                }
            } catch (error) {
                switch (error.response.status) {
                    case 422:
                        this.$flashMessage.show({
                        type: "error",
                        title: "유효하지 않은 데이터 입력입니다.",
                        message: "유효하지 않은 데이터 입력입니다.",
                        });
                        break;
                    case 401:
                        setTimeout(() => this.$router.push("/login"), 1000);
                        this.$flashMessage.show({
                        type: "error",
                        title: "로그인이 필요합니다.",
                        //message: "로그인이 필요합니다.",
                        });
                        break;
                    case 500:
                        this.$flashMessage.show({
                            type: "error",
                            title: error.response.data.message,
                            message: error.response.data.message,
                        });
                        break;
                    default:
                        this.$flashMessage.show({
                            type: "error",
                            title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
                            message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
                        });
                        break;
                }
            }
        },
    },
}
